import React from 'react';

export class ContextNotProvidedError extends Error {
  constructor(name: string) {
    super(`[${name}] - Context has not been provided`);
  }
}

const createContext = function <T>(name: string): [React.Context<T>, () => T] {
  const symbol = Symbol(name);
  const context = React.createContext<T | symbol>(symbol);
  context.displayName = name;

  const useContext = (): T => {
    const value = React.useContext(context);

    if (value === symbol) {
      throw new ContextNotProvidedError(name);
    }

    return value as T;
  };

  return [context as React.Context<T>, useContext];
};

export default createContext;
